import { CloseOutlined } from '@ant-design/icons'

import Box from '~/core/Box'
import getColor from '~/lib/getColor'

const CloseIcon = () => (
    <Box
        borderLeft={`1px solid ${getColor('blackAlpha09')}`}
        data-test-target="close-im-dfm-modal"
        margin="16px 0"
        padding="2px 18px"
    >
        <CloseOutlined
            style={{ fontSize: '18px', color: getColor('blackAlpha45') }}
        />
    </Box>
)

export default CloseIcon
